// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__21dLf","head":"ProcedureTableInfo_head__2Cc30"};